<template>
  <div>
    <div class="info-container mb-10 form-container mx-auto">
      <h5 class="text-lg">{{ $trans.get("registration.address-title") }}</h5>
    </div>
    <div class="form-container mx-auto">
      <div class="form-container__inputs">
        <p class="mb-3">{{ $trans.get('registration.type-address') }}</p>
        <floating-select-input
            name="type"
            :initialValue="form.address.type.value"
            :options="[
              { label: 'Calle (C.)', value: 'carrer' },
              { label: 'Avenida (Avda.)', value: 'av' },
              { label: 'Plaza (Pza.)', value: 'pza' },
              { label: 'Paseo (P.º)', value: 'pº' },
              { label: 'Travesía (Trv.)', value: 'trv' },
              { label: 'Glorieta (Gta.)', value: 'gta' },
              { label: 'Ronda (Rda.)', value: 'rda' },
              { label: 'Camino (Cno.)', value: 'cno' },
              { label: 'Pasaje (Pje.)', value: 'pje' },
              { label: 'Vía (Vía)', value: 'via' },
              { label: 'Carretera (Ctra.)', value: 'carretera' },
            ]"
            @handle-change="handleAddress"
            :required="true"
          />
        <div class="grid md:grid-cols-2 gap-4 mt-5">
          <floating-input
            v-for="(item, index) in form.address.address"
            :key="index"
            :name="item.name"
            :placeholder="$trans.get('registration.address.' + item.name)"
            :initialValue="item.value"
            @handle-change="handleAddressAddress"
            type="text"
            :required="checkIfRequired(item.name)"
            @input.native="removeError($event)"
          >
          </floating-input>
        </div>

        <floating-radio-button
          class="mt-6"
          name="isHabitual"
          :title="$trans.get('registration.isActual')"
          :initialValue="form.address.isHabitual.value"
          :options="[
            {
              label: 'Sí',
              value: 'si',
            },
            {
              label: 'No',
              value: 'no',
            },
          ]"
          @handle-change="handleAddress"
        ></floating-radio-button>
        <!-------------------->
      </div>

      <div v-if="form.address.isHabitual.value === 'no'"
        class="form-container mt-12"
      >
        <div class="info-container mb-10">
          <h5 class="text-lg">{{ $trans.get("registration.casual-title") }}</h5>
        </div>
        <div class="form-container__inputs">
          <!-- CASUAL ADDRESS DATA -->
          <p class="mb-3">{{ $trans.get('registration.type-address') }}</p>
          <floating-select-input
            name="casualType"
            :initialValue="form.address.casualType.value"
            :options="[
              { label: 'Calle (C.)', value: 'carrer' },
              { label: 'Avenida (Avda.)', value: 'av' },
              { label: 'Plaza (Pza.)', value: 'pza' },
              { label: 'Paseo (P.º)', value: 'pº' },
              { label: 'Travesía (Trv.)', value: 'trv' },
              { label: 'Glorieta (Gta.)', value: 'gta' },
              { label: 'Ronda (Rda.)', value: 'rda' },
              { label: 'Camino (Cno.)', value: 'cno' },
              { label: 'Pasaje (Pje.)', value: 'pje' },
              { label: 'Vía (Vía)', value: 'via' },
              { label: 'Carretera (Ctra.)', value: 'carretera' },
            ]"
            @handle-change="handleAddress"
            :required="true"
          />
          <div class="grid md:grid-cols-2 gap-4 mt-5">
            <floating-input
              v-for="(item, index) in form.address.casualAddress"
              :key="index"
              :name="item.name"
              :placeholder="$trans.get('registration.casual.' + item.name)"
              :initialValue="item.value"
              @handle-change="handleAddressCasual"
              type="text"
            >
            </floating-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      required: false,
    },
  },
  data: () => {
    return {
      form: {
        address: {
          type: {
            name: "type",
            value: "",
            errors: [],
          },
          address: {
            name: {
              name: "name",
              value: "",
              errors: [],
            },
            number: {
              name: "number",
              value: "",
              errors: [],
            },
            floor: {
              name: "floor",
              value: "",
              errors: [],
            },
            door: {
              name: "door",
              value: "",
              errors: [],
            },
            postal: {
              name: "postal",
              value: "",
              errors: [],
            },
            province: {
              name: "province",
              value: "",
              errors: [],
            },
            city: {
              name: "city",
              value: "",
              errors: [],
            },
            country: {
              name: "country",
              value: "",
              errors: [],
            },
          },
          isHabitual: {
            name: "isHabitual",
            value: "",
            errors: [],
          },
          casualType: {
            name: "casualType",
            value: "",
            errors: [],
          },
          casualAddress: {
            casualName: {
              name: "casualName",
              value: "",
              errors: [],
            },
            casualNumber: {
              name: "casualNumber",
              value: "",
              errors: [],
            },
            casualFloor: {
              name: "casualFloor",
              value: "",
              errors: [],
            },
            casualDoor: {
              name: "casualDoor",
              value: "",
              errors: [],
            },
            casualPostal: {
              name: "casualPostal",
              value: "",
              errors: [],
            },
            casualProvince: {
              name: "casualProvince",
              value: "",
              errors: [],
            },
            casualCity: {
              name: "casualCity",
              value: "",
              errors: [],
            },
            casualCountry: {
              name: "casualCountry",
              value: "",
              errors: [],
            },
          },
        },
      },
    };
  },
  methods: {
    checkIfRequired(name) {
        return name != 'door' && name != 'floor';
    },
    removeError(event) {
      event.target.classList.remove("border-red-500");
    },
    handleAddressAddress({ value, name }) {
      this.form.address.address[name].value = value;
    },
    handleAddressCasual({ value, name }) {
      this.form.address.casualAddress[name].value = value;
    },
    handleAddressFirstBasic({ value, name }) {
      this.form.address.tutors.first.basic[name].value = value;
    },
    handleAddressSecondBasic({ value, name }) {
      this.form.address.tutors.second.basic[name].value = value;
    },
    handleAddressFirstExtra({ value, name }) {
      this.form.address.tutors.first.extra[name].value = value;
    },
    handleAddressSecondExtra({ value, name }) {
      this.form.address.tutors.second.extra[name].value = value;
    },
    handleAddress({ value, name }) {
      this.$set(this.form.address, name, { ...this.form.address[name], value });
    }

  },

  created() {
    this.form.address.type.value = this.address?.type || 'carrer';

    if (!this.address) return;
  const array = this.form.address;

  for (const item in array.address) {
    if (array.address.hasOwnProperty(item)) {
      this.form.address.address[item].value = this.address[item];
    }
  }

  this.$set(this.form.address.isHabitual, "value", this.address.isHabitual);

  // casualType
  this.form.address.casualType.value = this.address.casualType || 'carrer';

  if (this.address.isHabitual === "no") {
    for (const item in array.casualAddress) {
      if (array.casualAddress.hasOwnProperty(item)) {
        this.form.address.casualAddress[item].value = this.address[item];
      }
    }
  }
}
};
</script>
